import {fabric} from 'fabric';
import DefaultSquare from '../nuclide/levelhelpers/DefaultSquare';
import RowColSquare from '../nuclide/levelhelpers/RowColSquare';
import SquareGrid from '../nuclide/levelhelpers/SquareGrid';

export default function createTwo(nuclide) {
    let items = [];

    if(nuclide.isRow || nuclide.isColumn) {
        new RowColSquare(nuclide, items, 4, false);
    } else {
        new DefaultSquare(nuclide, items, 4);

        let grid = new SquareGrid(items, nuclide, 4);
        grid.createGrid(2);
    }

    let group = new fabric.Group(items, {
        objectCaching: false,
        opacity: nuclide.opacity
    });

    return group;
};